import { Auth } from "aws-amplify";
import axios, { AxiosResponse } from "axios";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
} from "../../../data/protocols/http/http-client";
import toastUtils from "../../../utils/ToastUtils";

export class AxiosHttpClient implements HttpClient {
  constructor(private readonly baseUrl: string | undefined) {}

  async request(data: HttpRequest): Promise<HttpResponse> {
    let axiosResponse: AxiosResponse;
    try {
      const token = await this.updateAmplifyToken();
      axiosResponse = await axios.request({
        url: this.baseUrl + data.url,
        method: data.method,
        data: data.body,
        ...(data?.params && { params: data?.params }),
        headers: { ...data?.headers, ...token },
        paramsSerializer: (params) => {
          const searchParams = new URLSearchParams();
          Object.entries(params).forEach(([key, value]) => {
            if (Array.isArray(value)) {
              value.forEach((v) => searchParams.append(key, String(v)));
            } else if (value !== undefined && value !== null) {
              searchParams.append(key, String(value));
            }
          });
          return searchParams.toString();
        },
      });
    } catch (error: any) {
      axiosResponse = error.response;
    }

    switch (axiosResponse.status) {
      case 401:
      
        if (
          axiosResponse?.data?.message ===
          "AUTH ERROR InvalidCredentialsError: Credenciais inválidas"
        ) {
          toastUtils.showMessage({
            type: "error",
            message: "Aguarde até que a sua análise seja completada",
          });
        } else {
          toastUtils.showMessage({
            type: "info",
            message:
              "Não foi possível prosseguir. Se fez seu cadastro agora, aguarde até que a sua análise seja completada",
          });
        }
        // await Auth.signOut()
        break;

      default:
        break;
    }
    return {
      statusCode: axiosResponse.status,
      body: axiosResponse.data,
    };
  }

  updateAmplifyToken = async (): Promise<{ Authorization: string }> => {
    try {
      const session = await Auth.currentSession();
      return {
        Authorization: session.getIdToken().getJwtToken(),
      };
    } catch (_) {
      return {
        Authorization: this.baseUrl || "",
      };
    }
  };
}
